import { get, isArray, isString, uniq } from 'lodash';

export function getErrorMessage(data: unknown) {
    if (isString(data)) {
        return data;
    } else if (isArray(data)) {
        return uniq(data.map((item) => getErrorMessage(item))).join('\n');
    } else if (typeof data === 'object' && data !== null) {
        const field =
            get(data, 'value') ||
            get(data, 'detail') ||
            get(data, 'msg') ||
            get(data, 'message') ||
            get(data, 'data') ||
            get(data, 'err') ||
            get(data, 'error');

        return getErrorMessage(field);
    } else {
        return 'Something went wrong';
    }
}

export default function isOkResponse(response: unknown) {
    return get(response, ['result']) === 'OK';
}

export function throwResponseError(response: unknown) {
    const message = getErrorMessage(response);
    throw new Error(message);
}
